export default {
  title: 'Compose new message',
  label: {
    job: 'Job',
    subject: 'Subject',
    content: 'Content'
  },
  btn: {
    send: 'Send Message'
  },
  message: {
    sendSuccess: 'Send Success',
    noEmailAccount: 'This candidate do not have an email address, we cannot invite this candidate currently. Our SMS invitation is under developing. Coming SOON!',
    sendFail: 'Send Failed'
  }
}
